import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '../../services/user.service';
import { ToastMessageComponent } from 'src/app/common/toast-message/toast-message.component';

@Component({
  selector: 'app-password-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './password-modal.component.html',
  styleUrls: ['./password-modal.component.scss', '../../../app.component.scss', '../../../shared/base-modal.style.scss']
})
export class PasswordModalComponent implements OnInit {
  @ViewChild(ToastMessageComponent) toastMessage: ToastMessageComponent;

  // currentPassword: string = '';
  newPassword: string = '';
  confirmNewPassword: string = '';
  userId: string | null;

  constructor(
    public dialogRef: MatDialogRef<PasswordModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService
  ) {
    this.userId = localStorage.getItem('userId');
  }

  ngOnInit(): void {}

  onClose(): void {
    this.dialogRef.close();
  }

  onSubmit(f: NgForm) {
    if (!f.valid) {
      this.toastMessage.showToast("Please fill in all required fields.", "error");
      return;
    }

    if (this.newPassword !== this.confirmNewPassword) {
      this.toastMessage.showToast("New passwords do not match.", "error");
      return;
    }

    const payload = {
      password: this.newPassword,
      // currentPassword: this.currentPassword
    };

    // Log the payload to debug
    console.log('Payload being sent:', payload);

    this.userService.editPassword(this.userId, payload).subscribe({
      next: (data: any) => {
        this.toastMessage.showToast("Password has been successfully updated", "success");
        this.onClose();
      },
      error: (err: any) => {
        console.error('Error updating password:', err);
        this.toastMessage.showToast("Failed to update password", "error");
      }
    });
  }
}
